import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import AboutPage from './pages/AboutPage';
import OrderConfirmation from './pages/OrderConfirmation';

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [cart, setCart] = useState([]);
  const [darkMode, setDarkMode] = useState(false);
  const [orderData, setOrderData] = useState(null);

  // Load dark mode preference from localStorage
  useEffect(() => {
    const savedDarkMode = localStorage.getItem('darkMode') === 'true';
    setDarkMode(savedDarkMode);
    if (savedDarkMode) {
      document.documentElement.setAttribute('data-theme', 'dark');
    }
  }, []);

  // Toggle dark mode
  const toggleDarkMode = () => {
    const newDarkMode = !darkMode;
    setDarkMode(newDarkMode);
    localStorage.setItem('darkMode', newDarkMode);
    if (newDarkMode) {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
  };

  const handleAddToCart = (product) => {
    setCart([...cart, product]);
    alert(`${product.name} added to cart!`);
  };

  const handleRemoveFromCart = (index) => {
    setCart(cart.filter((_, i) => i !== index));
  };

  const handleOrderSuccess = (data) => {
    setOrderData(data);
    setCart([]); // Clear cart
    setCurrentPage('confirmation');
  };

  return (
    <div className="App" data-theme={darkMode ? 'dark' : 'light'}>
      <Header setCurrentPage={setCurrentPage} darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      
      {currentPage === 'home' && <HomePage setCurrentPage={setCurrentPage} />}
      {currentPage === 'products' && <ProductsPage onAddToCart={handleAddToCart} />}
      {currentPage === 'cart' && <CartPage cart={cart} setCurrentPage={setCurrentPage} onRemove={handleRemoveFromCart} />}
      {currentPage === 'checkout' && <CheckoutPage cart={cart} setCurrentPage={setCurrentPage} onOrderSuccess={handleOrderSuccess} />}
      {currentPage === 'about' && <AboutPage />}
      {currentPage === 'confirmation' && <OrderConfirmation orderData={orderData} setCurrentPage={setCurrentPage} />}
      
      <Footer />
    </div>
  );
}

export default App;